var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOtroVerde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 67,
    viewBox: "0 0 65 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9227",
    "data-name": "Group 9227",
    transform: "translate(483 -571)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13494",
    "data-name": "Rectangle 13494",
    width: 65,
    height: 67,
    rx: 32.5,
    transform: "translate(-483 571)",
    fill: "#00ca7d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_008-menu-1",
    "data-name": "008-menu-1",
    transform: "translate(-463.605 592)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M9.113,12.569H3.456A3.46,3.46,0,0,1,0,9.113V3.456A3.46,3.46,0,0,1,3.456,0H9.113a3.46,3.46,0,0,1,3.456,3.456V9.113A3.46,3.46,0,0,1,9.113,12.569ZM3.456,1.676A1.783,1.783,0,0,0,1.676,3.456V9.113a1.783,1.783,0,0,0,1.781,1.781H9.113a1.783,1.783,0,0,0,1.781-1.781V3.456A1.783,1.783,0,0,0,9.113,1.676Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M281.113,12.569h-5.656A3.46,3.46,0,0,1,272,9.113V3.456A3.46,3.46,0,0,1,275.456,0h5.656a3.46,3.46,0,0,1,3.456,3.456V9.113A3.46,3.46,0,0,1,281.113,12.569ZM275.456,1.676a1.783,1.783,0,0,0-1.781,1.781V9.113a1.783,1.783,0,0,0,1.781,1.781h5.656a1.783,1.783,0,0,0,1.781-1.781V3.456a1.783,1.783,0,0,0-1.781-1.781Z",
    transform: "translate(-257.755)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M278.284,284.569a6.285,6.285,0,1,1,6.285-6.285A6.292,6.292,0,0,1,278.284,284.569Zm0-10.893a4.609,4.609,0,1,0,4.609,4.609A4.614,4.614,0,0,0,278.284,273.676Z",
    transform: "translate(-257.755 -257.755)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M9.113,284.569H3.456A3.46,3.46,0,0,1,0,281.113v-5.656A3.46,3.46,0,0,1,3.456,272H9.113a3.46,3.46,0,0,1,3.456,3.456v5.656A3.46,3.46,0,0,1,9.113,284.569ZM3.456,273.676a1.783,1.783,0,0,0-1.781,1.781v5.656a1.783,1.783,0,0,0,1.781,1.781H9.113a1.783,1.783,0,0,0,1.781-1.781v-5.656a1.783,1.783,0,0,0-1.781-1.781Z",
    transform: "translate(0 -257.755)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtroVerde);
export default __webpack_public_path__ + "static/media/OtroVerde.cf2fd920d1ecfd4da51d7aa8b73390ab.svg";
export { ForwardRef as ReactComponent };